import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { MessageBox, Message } from 'element-ui'
NProgress.configure({ showSpinner: false })
let hasRoles = true
const whiteList = ['/login', '/registerpage', '/404']
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if (store.state.routerlist.length > 0) {
        next()
        NProgress.done()
      } else {
        try {
          await store.dispatch('SET_USER')
          store.dispatch('generateRoutes').then((accessRoutes) => {
            if (hasRoles) {
              router.addRoute(accessRoutes[0])
              hasRoles = false
              next({ ...to, replace: true })
            } else {
              next()
            }
          })
        } catch (error) {
          Message.error(error || '请重新登录！')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      Message.warning('登录状态已过期请重新登录')
      next(`/login`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
